<img class="logo" src="assets/images/bidr_logo.svg" />
